export default {
  SET_TRANSACTION_DATA(state, transactionData) {
    state.transactions = transactionData;
  },
  SET_TRANSACTIONS_RECORDS(state, totalTransactions) {
    state.totalTransactions = totalTransactions;
  },
  SET_CURRENT_PAGE(state, data) {
    state.transactions.currentPage = data;
  },
};
